import { Form, FormElement, FormRenderProps } from "@progress/kendo-react-form"
import { handleInputChange } from "../../functions/inputFunctions/inputFunctions"
import Input from "../kendo/input"
import InputPassword from "../kendo/password"
import { ValidButton } from "../buttons/validButton"
import {  useConf } from "../../context/account/paramsAccount"
import { saveModeHorsligne } from "../../functions/localStorage/saveLocalStorage"
import { loadModeHorsligne } from "../../functions/HorsLigne/loadmodeHL"
import { useEffect, useState } from "react"
import { comparePassword } from "../../functions/crypt/hashPassword"
import ImageApp from "../../images/mobichef.svg"

export function FormulaireConnexionHl() {
    const { conf, setConf } = useConf()
    const [password, setPassword] = useState("")
    const [hash, sethash] = useState("")
    useEffect(() => {
        loadModeHorsligne('localPassword',conf)
            .then(data => {
                if (data) {
                    sethash(data)
                } else {
                    sethash("")
                }
            })
            .catch(error => console.error('Erreur lors du chargement des données hors ligne :', error));
    }, [])

    const ConnectApp = async (user: any) => {
        try {
            const existingData = await loadModeHorsligne('prestaHl',conf);
            const isMatch = await comparePassword(password, hash);
            if (isMatch) {
                const updatedData = existingData.map((item: any) => {
                    setConf((prevConf) => ({
                        ...prevConf,
                        // token:null,
                        user: { ...user, isConnected: true },
                    }))
                    return item;
                });

                await saveModeHorsligne(updatedData, 'prestaHl',conf);
            }
            else {

            }
        } catch (error) {
            console.error('Error during connection:', error);
            setConf((prevConf) => ({
                ...prevConf,
                user: { ...user, isConnected: false },
            }))
        }
    }
    const handleInputPasswordChange = (value: string) => {
        setPassword(value)
    }
    return (
        <div>
            <Form
                render={(formRenderProps: FormRenderProps) => (
                    <FormElement className="connexionforms">
                        <img src={`${ImageApp}`} alt="logo mobi-chef" className="logoMobiChef"></img>
                        <Input name={"Utilisateur"} onChange={(value: any) => { handleInputChange('user_code', setConf, conf.user, value) }} value={conf?.user.user_code} ></Input>
                        <InputPassword name={"Mot de Passe"} onChange={(value: any) => { handleInputPasswordChange(value) }} value={password}></InputPassword>
                        <div className="containerButton">
                            <ValidButton onClick={() => ConnectApp(conf.user)}> Connexion</ValidButton>
                        </div>
                    </FormElement>
                )}
            />

        </div>
    )
}